import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../api/agent";
import { AppResponse } from "../../../../models/app/AppResponse";
import {
  Order,
  ShopifyLocation,
} from "../../../../models/features/Order/Order";
import { AppFilter } from "../../../../models/app/AppModels";

export const quotationApi = createApi({
  reducerPath: "quotationApi",
  baseQuery: axiosBaseQuery(),

  endpoints: (build) => ({
    getQuotations: build.query<any, { paging: AppFilter }>({
      query: ({ paging }) => ({
        url: `api/CustomerQuotation/GetQuotations`,
        method: "post",
        data: paging,
      }),
    }),
    getQuotationById: build.query<AppResponse<any>, { id: string }>({
      query: ({ id }) => ({
        url: `api/CustomerQuotation/GetQuotationById?quotationtId=` + id,
      }),
    }),
    markQuotesAsRead: build.mutation<any, void>({
      query: () => ({
        url: `api/CustomerQuotation/MarkQuotesAsRead`,
        method: "put",
        data: null,
      }),
    }),
  }),
});

export const {
  useGetQuotationsQuery,
  useGetQuotationByIdQuery,
  useMarkQuotesAsReadMutation,
} = quotationApi;
export const quotationReducer = quotationApi.reducer;
